import React from 'react';
import { Icon } from '../Icon/Icon';
import './ProductImage.css';
import classnames from 'classnames';
import { t } from '../../locales/translate';

interface Props {
  imgSrc: string;
  originalSrc?: string;
  isPreview?: boolean;
  isGallery?: boolean;
  setPreview?: () => void;
  setGallery?: () => void;
  deleteImage?: () => void;
}

export function ProductImage({
  imgSrc,
  originalSrc,
  isPreview,
  isGallery,
  setPreview,
  setGallery,
  deleteImage,
}: Props): JSX.Element {
  return (
    <div className="product-image">
      <img src={imgSrc} className="product-image__image" />
      <div className="product-image__icons-container">
        <Icon
          name="list"
          className={classnames('product-image__icon', {
            'product-image__icon--preview': isPreview,
          })}
          onClick={setPreview}
        />
        <Icon
          name="image"
          className={classnames('product-image__icon', {
            'product-image__icon--preview': isGallery,
          })}
          onClick={setGallery}
        />
        <Icon className="product-image__icon" name="trash" onClick={deleteImage} />
        {originalSrc && (
          <a
            href={originalSrc}
            download
            className="product-image__download"
            title={t.component.productImage.downloadOriginal}
          >
            <Icon className="product-image__icon" name="download--sm" />
          </a>
        )}
      </div>
    </div>
  );
}
